import { z } from 'zod/v4';
import {
  BUILT_FORM_VALUES,
  CONSTRUCTION_AGE_BAND_VALUES,
  HEATING_SYSTEM_VALUES,
  PROPERTY_TYPE_VALUES,
  WALL_CONSTRUCTION_VALUES,
  WALL_INSULATION_VALUES,
  WINDOW_GLAZING_VALUES,
} from './propertyInfoOptions';

export const PROPERTY_INFO_SCHEMA = z.object({
  propertyType: z.enum(PROPERTY_TYPE_VALUES, {
    message: 'Property type is required',
  }),
  builtForm: z.enum(BUILT_FORM_VALUES, {
    message: 'Built form is required',
  }),
  constructionAgeBand: z.enum(CONSTRUCTION_AGE_BAND_VALUES).optional(),
  floorAreaM2: z.string().min(1, 'Floor area is required'),
  numBedrooms: z.string().min(1, 'Number of bedrooms is required'),
  heatingSystem: z.enum(HEATING_SYSTEM_VALUES, {
    message: 'Heating system is required',
  }),
  wallConstruction: z.enum(WALL_CONSTRUCTION_VALUES, {
    message: 'Wall construction is required',
  }),
  wallInsulation: z.enum(WALL_INSULATION_VALUES, {
    message: 'Wall insulation is required',
  }),
  windowGlazingType: z.enum(WINDOW_GLAZING_VALUES, {
    message: 'Window glazing type is required',
  }),
  loftInsulationMm: z.string().min(1, 'Loft insulation is required'),
  numStoreys: z.string().optional(),
});

export type PropertyInfoForm = z.infer<typeof PROPERTY_INFO_SCHEMA>;
